import React, { useEffect, useState } from "react";
import { Button } from "@aws-amplify/ui-react";
import PasswordContainer from '../Components/PasswordContainer/PasswordContainer';
import AlreadyHaveAnAccount from "../Components/AlreadyHaveAnAccount";
import { buildCurrentLocation, signUp, splitName, SS_REDIRECT_URL } from "../GetStarted.service";
import { Container } from "./Styled";
import { useSearchParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import toast, { Toaster } from 'react-hot-toast';
import { authenticate } from "../../Signup/Signup.service";
import { determineUserType } from "../../../utils/UserType";
import { ColorRing } from "react-loader-spinner";


const StepThree = ({userPassword, setUserPassword, email, fullName, verticalChoice, setProgress}:any) => {
    const [passwordIsValid, setPasswordIsValid] = useState(false);
    const [isDisabledButton, setDisabledButton] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [searchParams] = useSearchParams();
    const redirectUrl: string = searchParams.get("redirect_to") || SS_REDIRECT_URL;
    const recaptchaRef = React.createRef();
    const chosenVertical = verticalChoice || "other";

    useEffect(()=> {
        setProgress('45');
        window.dataLayer.push({event: "page_view",
            page_location: buildCurrentLocation,
            page_title: "SignUp Step 3"
        });
        window.dataLayer.push({event: "signup_choose_vertical",
            business_vertical: chosenVertical
        });

    }, [])

    useEffect(() => {
        if (passwordIsValid) {
            setDisabledButton(false)
            window.dataLayer.push({event: "signup_set_password"});
        }
    }, [passwordIsValid])

    const handleNextStep = () =>{
        userSignUp()
    }


    const userSignUp = async () => {
        const userType = determineUserType();
        const startTime = new Date();
        setDisabledButton(true);
        setIsLoading(true)
        const captcha = await recaptchaRef.current.executeAsync()
        const [given_name, family_name] = splitName(fullName)
        try {
            const user = await signUp(
                email || localStorage.getItem("userEmail"),
                userPassword,
                given_name || localStorage.getItem("userFName"),
                family_name || localStorage.getItem("userLName"),
                Intl.DateTimeFormat().resolvedOptions().timeZone,
                chosenVertical,
                captcha
            )

            window._hsp .push([
                'trackCustomBehavioralEvent',
                {
                    name: "pe4023006_sign_up_with_vertical",
                    properties: {
                        full_name: fullName,
                        email: email,
                        vertical: chosenVertical,
                    },
                },
            ]);

            await authenticate(userPassword, user, user.username, "selfService", startTime, window.location.href, redirectUrl);

        } catch(e) {
            console.log(e);
            let message = "Something went wrong"
            if ((e as any).code === "UsernameExistsException" && email) {
                message = "Email is already in use!"
            } else if ((e as any).code === "UserLambdaValidationException") {
                message = "Please solve the reCAPTCHA"
            }
            toast.error(message, {
                id: 'signupFail',
                duration: 6000,
                style: {
                    padding: "1em",
                    fontSize: "14px",
                    fontWeight: "bold",
                }
            })
            window.dataLayer.push({event: "signup_completion_fail",
                fail_reason: message,
                method: "email"
            });

            setDisabledButton(false);
            setIsLoading(false)
        }
    }

    return (
        <Container>
            <div className="step-container step-container-three">
                <div className="BlackTitle">Create your Verbit Account</div>
                <PasswordContainer userPassword={userPassword} setUserPassword={setUserPassword} passwordIsValid={passwordIsValid}
                                setPasswordIsValid={setPasswordIsValid}/>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6Les4oQqAAAAACoToV1rUFm42iMA46prk-Uh3aay"
                    size="invisible"
                />
                <Button
                    className="customButton"
                    isFullWidth={true}
                    onClick={handleNextStep}
                    isDisabled={!passwordIsValid || isDisabledButton}
                >
                    <ColorRing
                        visible={isLoading}
                        height="2em"
                        width="2em"
                        ariaLabel="color-ring-loading"
                        wrapperClass="color-ring-wrapper"
                        colors={['#fff', '#fff', '#fff', '#fff', '#fff']}
                    />
                    Sign Up
                </Button>
                <AlreadyHaveAnAccount redirectTo={SS_REDIRECT_URL}/>
            </div>
            <Toaster
              position="bottom-center"
            />
        </Container>
    );
};

export default StepThree;
